import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import OutsideNotifier from '../outsideNotifier';
import { useDispatch } from 'react-redux';
import { deleteAllCookies } from 'utils/commonFunctions';
import Button from '../button';
import { resetCreateTeamReduxState } from 'store/slice/loginSlice';

const Logout = () => {
  const [loginDropdown, setLoginDropdown] = useState(false);
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const handleLogout = async () => {
    const logoutRequest = {
      postLogoutRedirectUri: '/top-picks/home',
      // postLogoutRedirectUri: "https://www.icc-cricket.com", // Specify the post-logout redirect URI
      policy: 'B2C_1A_SIGNINSIGNUP' // Specify the policy if needed
    };
    deleteAllCookies(false);
    localStorage.clear();
    // Reset Redux States
    dispatch(resetCreateTeamReduxState());
    await instance.logoutRedirect(logoutRequest);
  };
  return (
    <>
      <OutsideNotifier onClose={() => setLoginDropdown(false)}>
        <div className='si-logout'>
          <div className='si-logout__icon'>
            {/* <Button
              variant={'onlyIcon'}
              btnCls={'si-btn__login'}
              iconCls={'lms-user'}
              onClick={() => {
                setLoginDropdown(!loginDropdown);
              }}
            /> */}
            <Button
              variant={'onlyIcon'}
              classes={'si-btn__login'}
              icon={'lms-user'}
              onClick={() => {
                setLoginDropdown(!loginDropdown);
              }}
            ></Button>
          </div>
          <div className={`si-logout__dropdown ${loginDropdown ? 'si-active' : ''}`}>
            <ul>
              <li>
                <Button
                  variant={'primaryLink'}
                  classes={'si-btn__login si-noClick'}
                  icon={'lms-user'}
                  leadingIcon={true}
                  onClick={() => {}}
                >
                  {accounts[0]?.name}
                </Button>
              </li>
              <li>
                {/* <Button
                  btnCls={'si-btn__logout'}
                  icon={'lms-exit'}
                  btnText={'Logout'}
                  onClick={() => {
                    handleLogout();
                  }}
                /> */}

                <Button
                  variant={'primaryLink'}
                  transKey={'cta_logout'}
                  classes={'si-btn__login'}
                  icon={'lms-exit'}
                  leadingIcon={true}
                  onClick={() => {
                    handleLogout();
                  }}
                >
                  Logout
                </Button>
              </li>
            </ul>
          </div>
        </div>
      </OutsideNotifier>
    </>
  );
};

export default Logout;
